export const modalModule = {
  namespaced: true,
  state: {
    active: false,
    type: null,
    content: null,
    playlist: null
  },
  getters: {},
  mutations: {
    setStatus (state, payload) {
      state.active = payload
    },
    setContent (state, payload) {
      state.content = payload
    },
    setType (state, payload) {
      state.type = payload
    },
    setMediaPlaylist (state, payload) {
      state.playlist = payload
    }
  },
  actions: {
    setActive (context, payload) {
      return new Promise((resolve) => {
        context.commit('setType', payload.type)
        context.commit('setContent', payload)
        context.commit('setStatus', true)
        resolve(true)
      })
    },
    setMediaPlaylist (context, payload) {
      // return this.$store.getters;
      let playArray = [];
      payload.forEach(id => {
        playArray.push( context.rootGetters["scenarioModule/getInject"](id) )
      });
      
      context.commit('setMediaPlaylist', playArray)
      // context.commit('setStatus', true)
    },
    closeModal (context) {
      context.commit('setContent', null)
      context.commit('setStatus', false)
      context.commit('setType', null)
      context.commit('setMediaPlaylist', null)
    }
  }
}
